import IGlobalConfig from "../types/IGlobalConfig";

const RTDB_CONFIG_WAIT_MS = 8_000;

export function getRtdbConfigWaitMs(): number {
  return RTDB_CONFIG_WAIT_MS;
}

export function buildGlobalConfigRestUrl(databaseUrl: string): string {
  const base = databaseUrl.endsWith("/") ? databaseUrl : `${databaseUrl}/`;
  return `${base}global/config.json`;
}

export function getFirebaseDatabaseUrlFromWindow(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  const databaseURL = (window as Window & { App?: { firebase?: { databaseURL?: string } } })
    .App?.firebase?.databaseURL;
  if (!databaseURL || typeof databaseURL !== "string") {
    return null;
  }
  return databaseURL;
}

export async function fetchGlobalConfigFromRest(
  databaseUrl?: string | null
): Promise<IGlobalConfig | null> {
  const urlSource = databaseUrl ?? getFirebaseDatabaseUrlFromWindow();
  if (!urlSource) {
    return null;
  }
  const response = await fetch(buildGlobalConfigRestUrl(urlSource), {
    credentials: "omit",
  });
  if (!response.ok) {
    return null;
  }
  const data = (await response.json()) as IGlobalConfig | null;
  if (!data || typeof data !== "object" || !data.authServiceUrl) {
    return null;
  }
  return data;
}

if (__DEV__) {
  if (
    !(
      buildGlobalConfigRestUrl("https://viewspark-production.firebaseio.com/") ===
      "https://viewspark-production.firebaseio.com/global/config.json"
    )
  ) {
    console.error("globalConfigRest: REST URL builder");
  }
}
